<template>
  <div class="self-mask">
    <el-dialog
      :close-on-click-modal="false"
      :title="fileType == 1 ? '视频预览' : '音频预览'"
      :visible.sync="showPreview"
      width="700px"
      center
      @close="handleClose"
    >
      <div class="dialog-content">
        <video
          v-if="fileType == 1"
          class="video-dom"
          :src="url"
          width=""
          height=""
          controls
        ></video>
        <audio v-else-if="fileType == 2" controls :src="url"></audio>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "HzxmanageVideoPreview",

  data() {
    return {
      showPreview: false,
      url: "",
      fileType: 1,
    };
  },

  mounted() {},

  methods: {
    init() {
      this.showPreview = true;
    },
    handleClose() {
      setTimeout(() => {
        this.$destroy(true);
        this.$el && this.$el.parentNode.removeChild(this.$el);
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
.self-mask {
  position: fixed;
  z-index: 9999999999;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  background-color: rgba($color: #000000, $alpha: 0.5);
}
.dialog-content {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60vh;
  overflow: hidden;
  .video-dom {
    width: 100%;
    height: 100%;
  }
  audio {
    width: 400px;
  }
}
</style>
